import React, { useEffect, useState } from "react";
import { useAuth } from "./AuthProvider";
import "./PhoneGate.css";

const BOT_LINK = "https://t.me/LalaGames_bot";

export default function PhoneGate({ children }) {
  const { user, refreshUser, phoneStatus } = useAuth();
  const [waiting, setWaiting] = useState(false);
  const [declined, setDeclined] = useState(false);

  const tg = window.Telegram && window.Telegram.WebApp;
  const insideTelegram = !!(tg && tg.initData);
  const canRequest = !!(tg && typeof tg.requestContact === "function");
  const mustShare = insideTelegram && user && user.telegram_id && phoneStatus === "missing";

  useEffect(() => {
    if (!waiting || !mustShare) return undefined;
    let tries = 0;
    const id = setInterval(() => {
      tries += 1;
      refreshUser();
      if (tries >= 15) {
        clearInterval(id);
        setWaiting(false);
      }
    }, 2000);
    return () => clearInterval(id);
  }, [waiting, mustShare]);

  if (!mustShare) return children;

  const requestPhone = () => {
    setDeclined(false);
    try {
      tg.requestContact((shared) => {
        if (shared) {
          setWaiting(true);
        } else {
          setDeclined(true);
        }
      });
    } catch (e) {
      setDeclined(true);
    }
  };

  const openBot = () => {
    if (tg && typeof tg.openTelegramLink === "function") {
      tg.openTelegramLink(BOT_LINK);
    } else {
      window.location.href = BOT_LINK;
    }
  };

  return (
    <div className="phonegate">
      <div className="phonegate__card">
        <div className="phonegate__icon">📱</div>
        <h1 className="phonegate__title">Share your phone number</h1>
        <p className="phonegate__text">
          Your phone number is required to play, deposit and withdraw.
        </p>
        <p className="phonegate__text phonegate__text--am">
          ለመጫወት፣ ገንዘብ ለማስገባት እና ለማውጣት የስልክ ቁጥርዎ ያስፈልጋል።
        </p>

        {canRequest && (
          <button
            type="button"
            className="phonegate__btn"
            onClick={requestPhone}
            disabled={waiting}
          >
            {waiting ? "Checking..." : "📱 Share phone number"}
          </button>
        )}

        {declined && (
          <p className="phonegate__warn">
            You need to share your phone number to continue.
          </p>
        )}

        <p className="phonegate__hint">
          {canRequest
            ? "Or open the bot, send /start and share or type your number there."
            : "Open the bot, send /start and share or type your number there."}
        </p>
        <button type="button" className="phonegate__link" onClick={openBot}>
          Open bot chat
        </button>
      </div>
    </div>
  );
}
